import { FC } from 'react';
import classNames from 'classnames';
import { IconButton, IconButtonProps } from '@lambdacurry/component-library';

export const IconButtonPrimary: FC<IconButtonProps> = ({ className, ...props }) => (
  <IconButton className={classNames(`!text-brand-dark-green-500`, className)} {...props} />
);
